/* Collection filters and sort. The toolbar is a plain GET form that works on its own;
   this swaps in the new results with the Section Rendering API instead of reloading the page. */
(() => {
  const root = document.querySelector("[data-collection]");
  const form = root && root.querySelector("[data-col-form]");
  if (!form) return;
  const sectionId = root.dataset.section;
  const action = form.getAttribute("action");
  // Parts of the page that change with the filters. The count is a live region, so it's updated in place.
  const parts = ["[data-col-filters]", "[data-col-sort]", "[data-col-results]"];
  let controller;

  const query = () => new URLSearchParams(new FormData(form)).toString();

  async function update(search, push) {
    if (controller) controller.abort();
    controller = new AbortController();
    const focusId = document.activeElement && root.contains(document.activeElement) ? document.activeElement.id : "";
    const url = action + (search ? "?" + search : "");
    root.classList.add("is-busy");
    try {
      const sep = search ? "&" : "?";
      const res = await fetch(url + sep + "section_id=" + encodeURIComponent(sectionId), { signal: controller.signal });
      if (!res.ok) throw new Error(res.status);
      const doc = new DOMParser().parseFromString(await res.text(), "text/html");
      parts.forEach(sel => {
        const now = root.querySelector(sel), next = doc.querySelector(sel);
        if (now && next) now.replaceWith(next);
      });
      const count = root.querySelector("[data-col-count]"), nextCount = doc.querySelector("[data-col-count]");
      if (count && nextCount) count.textContent = nextCount.textContent;
      if (push) history.pushState({ col: true }, "", url);
      const again = focusId && document.getElementById(focusId);
      if (again) again.focus();
    } catch (err) {
      // Anything but a newer request cancelling this one: fall back to a normal page load
      if (err.name !== "AbortError") location.href = url;
    } finally {
      root.classList.remove("is-busy");
    }
  }

  form.addEventListener("change", () => update(query(), true));
  form.addEventListener("submit", e => { e.preventDefault(); update(query(), true); });
  root.addEventListener("click", e => {
    const clear = e.target.closest("[data-col-clear]");
    if (!clear) return;
    e.preventDefault();
    update(new URL(clear.href).searchParams.toString(), true);
  });
  window.addEventListener("popstate", () => update(location.search.slice(1), false));
})();
